import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import dompurify from "isomorphic-dompurify";
import { getConfig } from "@jti/fe-common";
import { useUser } from "../../../../hooks/useUser";
import { FlavorFinderSkipButton, FlavorFinderStartQuizButton } from "../Buttons/FlavorFinderButtons";
import { useFlavorFinderContext } from "../Provider/FlavorFinderContextProvider";
import { FlavorFinderHeader } from "../Header/FlavorFinderHeader";
import "./FlavorFinderIntro.scss";
import { useCurrentBreakpoint } from "../../../../index";
const { sanitize } = dompurify;
export const FlavorFinderIntro = () => {
    const { currentBreakpoint } = useCurrentBreakpoint();
    const { startQuiz, flavorFinderData } = useFlavorFinderContext();
    const config = getConfig();
    const { isUserLoggedIn } = useUser();
    const { titleLoggedIn, titleNonLoggedIn, subtitle, indicatorOverrideLabel, introBackgroundImage, smallIntroBackgroundImage, mediumIntroBackgroundImage, introBackgroundVideo, mediumIntroBackgroundVideo, smallIntroBackgroundVideo, ctaLabelStartLoggedIn, ctaLabelStartNonLoggedIn, ctaLabelLoginToStart, } = flavorFinderData.intro;
    const getVideoAndBackgroundImage = () => {
        switch (currentBreakpoint) {
            case "small":
                return {
                    backgroundImage: smallIntroBackgroundImage,
                    video: smallIntroBackgroundVideo,
                };
            case "medium":
                return {
                    backgroundImage: mediumIntroBackgroundImage,
                    video: mediumIntroBackgroundVideo,
                };
            case "large":
            default:
                return {
                    backgroundImage: introBackgroundImage,
                    video: introBackgroundVideo,
                };
        }
    };
    const goToLoginPage = () => {
        window.location.href = `${config.AUTH_PAGE_URL}#login?returnUrl=${config["base-url"]}`;
    };
    const { backgroundImage, video } = getVideoAndBackgroundImage();
    const containerStyle = video ? {} : { backgroundImage: `url('${backgroundImage}')` };
    return (_jsxs("div", { style: containerStyle, className: "flavorfinder__intro", "data-testid": "flavor-finder-intro", children: [_jsx(FlavorFinderHeader, { title: isUserLoggedIn ? titleLoggedIn : titleNonLoggedIn, infoText: indicatorOverrideLabel }), _jsxs("div", { className: "flavorfinder__intro-content", children: [_jsx("div", { className: "flavorfinder__intro-subtitle", dangerouslySetInnerHTML: { __html: sanitize(subtitle) } }), video && _jsx("video", { className: "flavorfinder__intro-video", src: video, autoPlay: true, muted: true, loop: true })] }), _jsxs("div", { className: "flavorfinder__footer", children: [!isUserLoggedIn && _jsx(FlavorFinderStartQuizButton, { onClick: goToLoginPage, label: ctaLabelLoginToStart }), !isUserLoggedIn && _jsx(FlavorFinderSkipButton, { label: ctaLabelStartNonLoggedIn, onClick: startQuiz }), isUserLoggedIn && _jsx(FlavorFinderStartQuizButton, { label: ctaLabelStartLoggedIn, onClick: startQuiz })] })] }));
};
//# sourceMappingURL=FlavorFinderIntro.js.map